import styles from './style.module.css';
import imgPontosTotais from '../../../../assets/images/icon-pontos-totais.png';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import { Card } from '../../../../components/Card';
import { useAuth } from '../../../../hooks/useAuth';
import { usePoints } from '../../../../hooks/usePoints';
import { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export function TotalPoints() {
  const { client } = useAuth();
  const { totalPoints, historicalInputs } = usePoints();
  const [expanded, setExpanded] = useState(false);

  const getCoinName = (count: number) => {
    if (count === 1) {
      return client?.coinName
        ? client.coinName.replace(/\(\w*\)/g, '')
        : 'Ponto';
    }
    return client?.coinName
      ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo)
      : 'Pontos';
  };

  return (
    <div
      className={`col-sm-12 col-md-6 d-flex pb-3 ${client?.settings?.redemptionPolicy ? 'col-lg-3' : 'col-lg-4'}`}
    >
      <Card
        style={{
          minHeight: '90px',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <div className="d-flex align-items-center justify-content-center">
          <img
            className={`me-3 ${styles.icon}`}
            src={imgPontosTotais}
            alt="moeda"
          />
          <div className="d-block">
            <p className="m-0 tiny-text">{getCoinName(totalPoints)} Totais</p>
            <p className="m-0 fs-4 fw-semibold">
              {numberWithCommas(totalPoints.toFixed(2))}{' '}
              <span className="tiny-text">
                {getCoinName(totalPoints).toLowerCase()}
              </span>
            </p>
          </div>
        </div>
        {historicalInputs.length > 0 && (
          <div className="mt-3 pt-3 border-top">
            <div
              className="d-flex justify-content-between align-items-center"
              onClick={() => setExpanded(!expanded)}
              style={{ cursor: 'pointer' }}
            >
              <p className="m-0 tiny-text">Histórico por ano</p>
              {expanded ? (
                <KeyboardArrowUpIcon fontSize="small" />
              ) : (
                <KeyboardArrowDownIcon fontSize="small" />
              )}
            </div>
            {expanded && (
              <div className="mt-2">
                {historicalInputs.map((item) => (
                  <div
                    key={item.year}
                    className="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span className="tiny-text">{item.year}</span>
                    <span className="fw-semibold">
                      {numberWithCommas(item.totalPoints.toFixed(2))}{' '}
                      {getCoinName(item.totalPoints).toLowerCase()}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </Card>
    </div>
  );
}
